
import {
  Vue, Component, Prop, Watch, Mixins,
} from 'vue-property-decorator';
import moment from 'moment';
import UtilsMixin from '@/mixins/UtilsMixin.vue';
import { CalendarEvent } from '@/types';
import FullDatePickerEvent from '@/components/FullDatePickerEvent.vue';

moment.locale('it');

@Component(
  {
    components: {
      FullDatePickerEvent,
    },
  },
)
export default class FullDatePickerDialog extends Mixins(UtilsMixin) {
  @Prop(Boolean) readonly value!: boolean;
  @Prop(Number)readonly operationId?: number | null;
  @Prop({ type: String, default: null }) readonly showBusyDatesType?: string | null;

  // La data da visualizzare (nel formato YYYY-MM-DD)
  @Prop({ type: String, default: null }) readonly date!: string | null;

  // L'eventuale orario di inizio e fine
  @Prop({ type: String, default: null }) readonly startTime!: string | null;
  @Prop({ type: String, default: null }) readonly endTime!: string | null;

  // Se true, nasconde gli orari
  @Prop({ type: Boolean, default: false }) readonly hideTime!: boolean;

  // Se true, visualizza la possibilità di selezionare la settimana
  @Prop({ type: Boolean, default: false }) readonly showWeekSelection!: boolean;

  // Se true, permette la selezione di una data
  @Prop({ type: Boolean, default: false }) readonly allowSingle!: boolean;

  // Se true, permette la selezione di una settimana
  @Prop({ type: Boolean, default: true }) readonly allowWeek!: boolean;

  // La modalità di selezione iniziale
  @Prop({ type: String, default: 'single' }) readonly initialMode!: 'single' | 'week';

  mode: 'single' | 'week' = 'week'

  calendarDateValue: string | null = null
  newValue: string | null = null
  newTextValue: string | null = null

  commissioningStartTime: string | null = null
  commissioningEndTime: string | null = null

  dialog = false
  valid = false

  // Il titolo del calendario (mese e anno normalmente)
  calendarTitle: string | null = null

  // L'elenco degli eventi da visualizzare nel calendario
  calendarEvents: CalendarEvent[] = []

  @Watch('value')
  onValueChange(val: boolean) {
    console.log(`${this.constructor.name}: onValueChange() val =`, val); // eslint-disable-line no-console

    this.dialog = val;

    // Se il dialog è stato aperto...
    if (val === true) {
      // Imposta il tipo di selezione iniziale
      this.mode = this.initialMode;

      // ... imposta la data mostrata dal calendario
      this.calendarDateValue = this.date
        ? moment(this.date).toISOString(true).substring(0, 10)
        : moment().toISOString(true).substring(0, 10);

      // ... imposta la data iniziale da visualizzare
      this.newValue = this.date
        ? moment(this.date).toISOString(true).substring(0, 10)
        : null;

      // ... imposta il valore del campo di testo
      if (this.mode === 'single') {
        // Selezione di una data singola

        // ... imposta il valore del campo di testo nel formato DD/MM/YYYY
        this.newTextValue = this.newValue
          ? moment(this.newValue, 'YYYY-MM-DD').format('DD/MM/YYYY')
          : null;

        // ... imposta l'orario di inizio
        this.commissioningStartTime = this.startTime;

        // ... imposta l'orario di fine
        this.commissioningEndTime = this.endTime;
      } else {
        // Selezione di una settimana

        // ... imposta il valore del campo di testo nel formato WW-GGGG
        this.newTextValue = this.newValue
          ? moment(this.newValue, 'YYYY-MM-DD').format('WW-GGGG')
          : null;
      }

      // ... aggiorna il titolo del calendario
      this.updateTitle();

      // ... aggiorna gli eventi del calendario
      this.updateCalendarEvents();
    }
  }

  @Watch('dialog')
  onDialogChange(val: boolean) {
    console.log(`${this.constructor.name}: onDialogChange() val =`, val); // eslint-disable-line no-console

    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  // Converte una settimana nel formato WW-GGGG in un Date
  weekToDate(val: string): Date | null{
    console.log(`${this.constructor.name}: weekToDate() val =`, val); // eslint-disable-line no-console

    if (!val) return null;

    // Se non è nel formato WW-GGGG, la data non è valida
    if (!val.match(/^\d{2}-\d{4}$/)) return null;

    const year = parseInt(val.substring(3, 7), 10); // 2025
    const week = parseInt(val.substring(0, 2), 10); // 01

    console.log(`${this.constructor.name}: weekToDate() year =`, year); // eslint-disable-line no-console
    console.log(`${this.constructor.name}: weekToDate() week =`, week); // eslint-disable-line no-console

    if (Number.isNaN(year) || Number.isNaN(week)) return null;
    if (week < 1 || week > 53) return null;

    // Converti la settimana specificata da `${year}-W${week}` rispettando il formato ISO 8601
    // in una data di tipo Date
    const date = moment(val, 'WW-GGGG').toDate();

    console.log(`${this.constructor.name}: weekToDate() date =`, date); // eslint-disable-line no-console

    return date;
  }

  // Rivela le modifiche a `mode`
  @Watch('mode')
  onMode(val: 'single' | 'week') {
    console.log(`${this.constructor.name}: onMode() val =`, val); // eslint-disable-line no-console

    console.log(`${this.constructor.name}: onMode() this.newValue =`, this.newValue); // eslint-disable-line no-console

    if (val === 'single') {
      // Selezione di una data singola

      // Imposta il valore del campo di testo nel formato DD/MM/YYYY
      this.newTextValue = this.newValue
        ? moment(this.newValue, 'YYYY-MM-DD').format('DD/MM/YYYY')
        : null;
    } else {
      // Selezione di una settimana

      // Imposta il valore del campo di testo nel formato WW-GGGG
      this.newTextValue = this.newValue
        ? moment(this.newValue, 'YYYY-MM-DD').format('WW-GGGG')
        : null;
    }
  }

  // Rileva la modifica del valore del campo di testo
  @Watch('newTextValue')
  onNewTextValue(val: string | null) {
    console.log(`${this.constructor.name}: onNewTextValue() val =`, val); // eslint-disable-line no-console

    if (this.mode === 'single') {
      // Selezione di una data singola

      // Trasforma in un valore di tipo Date prima di restituirlo
      const newValue = val
        ? moment(val, 'DD/MM/YYYY', true).toDate()
        : null;
      console.log(`${this.constructor.name}: onNewTextValue() newValue =`, newValue); // eslint-disable-line no-console

      // Se è una data valida, la memorizza in this.newValue nel formato corretto
      if (newValue && moment(newValue).isValid()) {
        this.newValue = moment(newValue).format('YYYY-MM-DD');
      } else if (newValue === null) {
        // Se è null, la memorizza in this.newValue (data cancellata)
        this.newValue = null;
      }
    } else {
      // Selezione di una settimana

      // Trasforma in un valore di tipo Date prima di restituirlo
      const textValue = val
        ? this.weekToDate(val)
        : null;

      console.log(`${this.constructor.name}: onNewTextValue() textValue =`, textValue); // eslint-disable-line no-console

      console.log(`${this.constructor.name}: onNewTextValue() moment(textValue).isValid() =`, moment(textValue).isValid()); // eslint-disable-line no-console

      // Se la data è valida...
      if (textValue && moment(textValue).isValid()) {
        // Verifica se la settimana corrispondente è diversa dalla settimana corrispondente attualmente selezionata
        const newWeek = moment(textValue).format('WW-GGGG');
        const currentWeek = this.newValue
          ? moment(this.newValue, 'YYYY-MM-DD').format('WW-GGGG')
          : null;

        console.log(`${this.constructor.name}: onNewTextValue() newWeek =`, newWeek); // eslint-disable-line no-console
        console.log(`${this.constructor.name}: onNewTextValue() currentWeek =`, currentWeek); // eslint-disable-line no-console

        // Se la settimana è diversa, la memorizza in this.newValue nel formato corretto
        if (newWeek !== currentWeek) {
          this.newValue = moment(textValue).format('YYYY-MM-DD');
        }
      } else if (textValue === null) {
        // Se è null, la memorizza in this.newValue (data cancellata)
        this.newValue = null;
      }
    }
  }

  // Rileva la modifica del valore del datepicker
  @Watch('newValue')
  onNewValue(val: string | null) {
    console.log(`${this.constructor.name}: onNewValue() val =`, val); // eslint-disable-line no-console

    if (this.mode === 'single') {
      // Selezione di una data singola

      // Trasforma in un valore di tipo Date prima di restituirlo
      const newValue = val
        ? moment(val, 'YYYY-MM-DD').toDate()
        : null;

      // Se è una data valida, la memorizza in this.newTextValue nel formato corretto
      if (newValue && moment(newValue).isValid()) {
        const newTextValue = moment(newValue).format('DD/MM/YYYY');
        if (this.newTextValue !== newTextValue) {
          this.newTextValue = newTextValue;
        }
      } else if (newValue === null) {
        // Se è null, la memorizza in this.newTextValue (data cancellata)
        if (this.newTextValue !== null) {
          this.newTextValue = null;
        }
      }
    } else {
      // Selezione di una settimana

      // Trasforma la data selezionata in un valore di tipo Date
      const newValueDate = val
        ? moment(val, 'YYYY-MM-DD').toDate()
        : null;
      console.log(`${this.constructor.name}: onNewValue() newValueDate =`, newValueDate); // eslint-disable-line no-console

      // Trasforma la data selezionata in un valore di tipo WW-GGGG
      const newValueWeek = newValueDate && moment(newValueDate).isValid()
        ? moment(newValueDate).format('WW-GGGG')
        : null;
      console.log(`${this.constructor.name}: onNewValue() newValueWeek =`, newValueWeek); // eslint-disable-line no-console

      // Se è null, la memorizza in this.newTextValue (data cancellata)
      if (newValueWeek === null) {
        this.newTextValue = null;
        console.log(`${this.constructor.name}: onNewValue() this.newTextValue = null`); // eslint-disable-line no-console
      }

      // Se la nuova settimana è diversa da quella precedente, la memorizza in this.newTextValue
      if (this.newTextValue !== newValueWeek) {
        console.log(`${this.constructor.name}: onNewValue() newValueWeek diverso dal precedente (${this.newTextValue})`); // eslint-disable-line no-console

        this.newTextValue = newValueWeek;
      }
    }
  }

  get commissioningStartTimeFormat() {
    // formatta l'orario in HH:mm o in HH mm o in HH.mm o HH,mm o con spazi iniziali o finali
    return /^\s*([01]?\d|2[0-3])[.:\s,]?([0-5]\d)\s*$/;
  }

  get commissioningStartTimeRules() {
    return [
      (v: string) => !!v || "L'orario di inizio è richiesto",
      (v: string) => this.commissioningStartTimeFormat
        .test(v) || "L'orario non è in formato corretto",
    ];
  }

  eventKey(event: CalendarEvent) {
    switch (event.type) {
      case 'installation':
        return `${event.type}-${event.date}-${event.details?.operationId}-${event.details?.installationType}`;
      case 'commissioning':
        return `${event.type}-${event.date}-${event.details?.operationId}`;
      default:
        return `${event.type}-${event.date}`;
    }
  }

  outlined(event: CalendarEvent) {
    return event.type === 'installation' && !event?.details?.installationDateConfirm;
  }

  onBlurTime() {
    console.log(`${this.constructor.name}: onBlurTime()`); // eslint-disable-line no-console

    // se l'orario è valido correggo eventualmente il formato in HH:mm
    if (this.commissioningStartTime
      && this.commissioningStartTimeFormat.test(this.commissioningStartTime)) {
      const match = this.commissioningStartTime.match(this.commissioningStartTimeFormat);
      const hours = match && 1 in match ? match[1] : null;
      const minutes = match && 2 in match ? match[2] : null;
      if (hours && minutes) {
        this.commissioningStartTime = `${hours.padStart(2, '0')}:${minutes}`;
      }
    }
  }

  onInputTime() {
    console.log(`${this.constructor.name}: onChangeTime()`); // eslint-disable-line no-console

    // se l'orario è valido aggiorno l'orario di fine
    if (this.commissioningStartTime
      && this.commissioningStartTimeFormat.test(this.commissioningStartTime)) {
      const match = this.commissioningStartTime.match(this.commissioningStartTimeFormat);
      const hours = match && 1 in match ? match[1] : null;
      const minutes = match && 2 in match ? match[2] : null;
      if (hours && minutes) {
        let endHours = parseInt(hours, 10) + 2;
        if (endHours > 23) {
          endHours -= 24;
        }
        const endHoursString = `${endHours}`.padStart(2, '0');
        this.commissioningEndTime = `${endHoursString}:${minutes}`;
      }
    } else {
      this.commissioningEndTime = null;
    }
  }

  onClearTime() {
    console.log(`${this.constructor.name}: onClearTime()`); // eslint-disable-line no-console

    this.commissioningEndTime = null;
  }

  // Controlla se la data è valida
  isValid(val: string | null) {
    // Se è null, la data è valida
    if (val === null) {
      return true;
    }

    // Controlla se la data è valida
    const date = moment(val, 'DD/MM/YYYY', true).toDate();
    return moment(date).isValid();
  }

  // Controlla se la data è valida
  isWeekValid(val: string | null) {
    // Se è null, la data è valida
    if (val === null) return true;

    // Se non è nel formato WW-GGGG, la data non è valida
    if (!val.match(/^\d{2}-\d{4}$/)) return false;

    // Estrae anno e numero della settimana da `val` che è nel formato WW-GGGG
    const year = parseInt(val.substring(3, 7), 10);
    const week = parseInt(val.substring(0, 2), 10);

    if (Number.isNaN(year) || Number.isNaN(week)) return false;
    if (week < 1 || week > 53) return false;

    const date = moment(val, 'WW-GGGG').toDate();

    return moment(date).isValid();
  }

  // È stata selezionata una data
  async onSelect() {
    console.log(`${this.constructor.name}: onSelect() newValue =`, this.newValue); // eslint-disable-line no-console

    const form = this.getForm(this.$refs.form as Vue);

    if (form && form.validate()) {
      // Se posso avere la visualizzazione per settimane ignoro gli orari
      if (this.showWeekSelection) {
        this.$emit('select', this.newValue, this.mode);
      } else {
        this.$emit('select', this.newValue, this.commissioningStartTime, this.commissioningEndTime);
      }
    }
  }

  async updateCalendarEvents() {
    console.log(`${this.constructor.name}: updateCalendarEvents()`); // eslint-disable-line no-console

    if (!this.operationId) return;

    const result = await this.$store.dispatch('checkBusyDatesForDate', { id: this.operationId, date: this.calendarDateValue, type: this.showBusyDatesType }) ?? [];

    if (result instanceof Error) {
      console.log(`${this.constructor.name}: updateCalendarEvents() error = `, result); // eslint-disable-line no-console
      this.calendarEvents = [];
    } else {
      this.calendarEvents = result as CalendarEvent[];
    }
  }

  isSameDay(date1: string | Date | null, date2: string | Date | null) {
    if (date1 === null || date2 === null) return false;

    const [year1, month1, day1] = moment(date1).format('YYYY-MM-DD').split('-');
    const [year2, month2, day2] = moment(date2).format('YYYY-MM-DD').split('-');

    return (year1 === year2) && (month1 === month2) && (day1 === day2);
  }

  mDay(date: string) {
    const [,, day] = date.split('-');

    if (day === '01') {
      const result = moment(date).format('MMM D');
      return result.charAt(0).toUpperCase() + result.slice(1);
    }

    return moment(date).format('D');
  }

  updateTitle() {
    this.$nextTick(() => {
      if (this.$refs.calendar === undefined) return;
      const calendar = this.getCalendar(this.$refs.calendar as Vue);
      if (calendar) {
        const result = `${calendar.title}`;
        this.calendarTitle = result.charAt(0).toUpperCase() + result.slice(1);
      }
    });
  }

  getEventColor(event) {
    return event.color;
  }

  onPrevMonth() {
    if (this.$refs.calendar === undefined) return;
    const calendar = this.getCalendar(this.$refs.calendar as Vue);
    if (calendar) calendar.prev();
    this.updateTitle();
    this.updateCalendarEvents();
  }

  onNextMonth() {
    if (this.$refs.calendar === undefined) return;
    const calendar = this.getCalendar(this.$refs.calendar as Vue);
    if (calendar) calendar.next();
    this.updateTitle();
    this.updateCalendarEvents();
  }

  onClickDate(date: string) {
    console.log(`${this.constructor.name}: onClickDate() date =`, date); // eslint-disable-line no-console

    this.newValue = date;
  }
}
